module.exports = __webpack_public_path__ + "img/ad_banner.8b5c87cd.png";